// src/components/common/Workout/TempoDesc.js
import React from "react";

/**
 * Turn a tempo string like "2-1-2-1" or "30s hold"
 * into a Phase-by-Phase description with line breaks.
 */
export default function describeTempo(data, tempo) {
  // console.log(data);
  // Hold variant: "30s hold"
  const holdMatch = tempo.match(/^(\d+)\s*s?\s*hold$/i);
  if (holdMatch) {
    const secs = holdMatch[1];
    const plural = secs === "1" ? "" : "s";
    return (
      <div>
        {data.hold} {secs} {data.s}
        {plural}.
      </div>
    );
  }

  // 4-part variant: "2-1-2-1"
  const parts = tempo.split("-").map((p) => p.trim());
  if (parts.length === 4 && parts.every((p) => /^\d+$/.test(p))) {
    const [phase1, pause1, phase2, pause2] = parts;
    const plural = (n) => (n === "1" ? "" : "s");
    return (
      <>
        <div>
          <strong>Phase 1: </strong>
          {data.phase1}
          <span className="text-color">
            {phase1} {data.s}
            {plural(phase1)}
          </span>
          .
        </div>
        <div>
          <strong>Phase 2: </strong>
          {data.phase2}
          <span className="text-color">
            {pause1} {data.s}
            {plural(pause1)}
          </span>
          .
        </div>
        <div>
          <strong>Phase 3: </strong> {data.phase3}
          <span className="text-color">
            {phase2} {data.s}
            {plural(phase2)}
          </span>
          .
        </div>
        <div>
          <strong>Phase 4: </strong> {data.phase4}
          <span className="text-color">
            {pause2} {data.s}
            {plural(pause2)}
          </span>
          .
        </div>
      </>
    );
  }

  // Fallback: just echo it
  return <div>{tempo}</div>;
}
